import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { PageContainer, CloseButton } from 'app/components/common';

import './styles.less';

export const PageAlert = ( props ) => {
    const [ isVisible, setVisible ] = useState( false );

    // Construct the classes to use for the root component.
    const classes = classnames(
        'page-alert',
        { 'hidden': !isVisible },
        { [ props.className ]: Boolean( props.className ) },
    );

    useEffect( () => {
        setVisible( props.visible );
    }, [ props.visible ] );

    return (
        <div className={ classes } style={ props.style }>
            <div className="page-alert-content-container">
                { /* Wrap in page container for padding and max width. */ }
                <PageContainer>
                    <div className="page-alert-header">
                        <CloseButton onClick={ props.onClose } className="page-alert-close-button" />
                    </div>
                    <div className="page-alert-content">
                        { props.children }
                    </div>
                </PageContainer>
            </div>
        </div>
    );
};

PageAlert.defaultProps = {
    className: undefined,
    style: undefined,
    visible: false,
    onClose: undefined,
};

PageAlert.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    visible: PropTypes.bool,
    onClose: PropTypes.func,
};
